'use client'
import React from 'react'
import CTHeaderContainer from '../variants/cleartrip'
import FlyinHeaderContainer from '../variants/flyin'
import { useFeatures } from '@/src/hooks/useFeatures'

interface HeaderContainerProps {
    hideSignIn?: boolean
    domainCountry?: string
    showVisa?: boolean
    /** Omit to fall back to the resolved feature config below — most callers other than
     * ResponsiveHeader (which also knows the AE-domain state) don't pass this explicitly. */
    showFlightsHotels?: boolean
    /** Active vertical resolved server-side (from the request path) for nav highlighting. */
    activeVertical?: string | null
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({
    hideSignIn = false,
    domainCountry,
    showVisa = false,
    showFlightsHotels,
    activeVertical = null
}) => {
    const { FLIGHTS_HOTELS } = useFeatures()
    const resolvedShowFlightsHotels = showFlightsHotels ?? !!FLIGHTS_HOTELS
    const showFlyinHeader = domainCountry === 'FEG' || domainCountry === 'FSA' || domainCountry === 'FAE'

    return showFlyinHeader ? (
        <FlyinHeaderContainer
            hideSignIn={hideSignIn}
            showVisa={showVisa}
            showFlightsHotels={resolvedShowFlightsHotels}
            activeVertical={activeVertical}
        />
    ) : (
        <CTHeaderContainer hideSignIn={hideSignIn} showVisa={showVisa} activeVertical={activeVertical} />
    )
}

export { HeaderContainer }
export default HeaderContainer
